"use strict";

var _defineProperty2 = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");
var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");
var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");
var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");
var _assertThisInitialized = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/assertThisInitialized");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultFilterStyles = exports.default = void 0;
var _core = require("@material-ui/core");
var _Button = _interopRequireDefault(require("@material-ui/core/Button"));
var _Checkbox = _interopRequireDefault(require("@material-ui/core/Checkbox"));
var _FormControl = _interopRequireDefault(require("@material-ui/core/FormControl"));
var _FormControlLabel = _interopRequireDefault(require("@material-ui/core/FormControlLabel"));
var _FormGroup = _interopRequireDefault(require("@material-ui/core/FormGroup"));
var _Input = _interopRequireDefault(require("@material-ui/core/Input"));
var _InputLabel = _interopRequireDefault(require("@material-ui/core/InputLabel"));
var _ListItemText = _interopRequireDefault(require("@material-ui/core/ListItemText"));
var _MenuItem = _interopRequireDefault(require("@material-ui/core/MenuItem"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Select = _interopRequireDefault(require("@material-ui/core/Select"));
var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));
var _classnames = _interopRequireDefault(require("classnames"));
var _styles = require("@material-ui/core/styles");
var _lodash = _interopRequireDefault(require("lodash.clonedeep"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
  if (typeof input !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
var defaultFilterStyles = function defaultFilterStyles(theme) {
  return {
    root: {
      backgroundColor: theme.palette.background.default,
      padding: '24px 24px 36px 24px',
      fontFamily: 'Roboto'
    },
    header: {
      flex: '0 0 auto',
      marginBottom: '16px',
      width: '100%',
      display: 'flex',
      justifyContent: 'space-between'
    },
    title: {
      display: 'inline-block',
      marginLeft: '7px',
      color: theme.palette.text.primary,
      fontSize: '14px',
      fontWeight: 500
    },
    noMargin: {
      marginLeft: '0px'
    },
    reset: {
      alignSelf: 'left'
    },
    resetLink: {
      marginLeft: '16px',
      fontSize: '12px',
      cursor: 'pointer'
    },
    filtersSelected: {
      alignSelf: 'right'
    },
    /* checkbox */
    checkboxListTitle: {
      marginLeft: '7px',
      marginBottom: '8px',
      fontSize: '14px',
      color: theme.palette.text.secondary,
      textAlign: 'left',
      fontWeight: 500
    },
    checkboxFormGroup: {
      marginTop: '8px'
    },
    checkboxFormControl: {
      margin: '0px'
    },
    checkboxFormControlLabel: {
      fontSize: '15px',
      marginLeft: '8px',
      color: theme.palette.text.primary
    },
    checkboxIcon: {
      width: '32px',
      height: '32px'
    },
    checkbox: {
      '&$checked': {
        color: theme.palette.primary.main
      }
    },
    checked: {},
    gridListTile: {
      marginTop: '16px'
    }
  };
};
exports.defaultFilterStyles = defaultFilterStyles;
var TableFilter = /*#__PURE__*/function (_react$default$Compon) {
  _inherits(TableFilter, _react$default$Compon);
  function TableFilter(props) {
    var _this;
    _classCallCheck(this, TableFilter);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(TableFilter).call(this, props));
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "filterUpdate", function (index, value, column, type, customUpdate) {
      var newFilterList = _this.state.filterList.slice(0);
      _this.props.updateFilterByType(newFilterList, index, value, type, customUpdate);
      _this.setState({
        filterList: newFilterList
      });
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleCheckboxChange", function (index, value, column) {
      _this.filterUpdate(index, value, column, 'checkbox');
      if (_this.props.options.confirmFilters !== true) {
        _this.props.onFilterUpdate(index, value, column, 'checkbox');
      }
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleDropdownChange", function (event, index, column) {
      var labelFilterAll = _this.props.options.textLabels.filter.all;
      var value = event.target.value === labelFilterAll ? [] : [event.target.value];
      _this.filterUpdate(index, value, column, 'dropdown');
      if (_this.props.options.confirmFilters !== true) {
        _this.props.onFilterUpdate(index, value, column, 'dropdown');
      }
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleMultiselectChange", function (index, value, column) {
      _this.filterUpdate(index, value, column, 'multiselect');
      if (_this.props.options.confirmFilters !== true) {
        _this.props.onFilterUpdate(index, value, column, 'multiselect');
      }
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleTextFieldChange", function (event, index, column) {
      _this.filterUpdate(index, event.target.value, column, 'textField');
      if (_this.props.options.confirmFilters !== true) {
        _this.props.onFilterUpdate(index, event.target.value, column, 'textField');
      }
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleCustomChange", function (value, index, column) {
      _this.filterUpdate(index, value, column.name, column.filterType);
      if (_this.props.options.confirmFilters !== true) {
        _this.props.onFilterUpdate(index, value, column.name, column.filterType);
      }
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "applyFilters", function () {
      _this.state.filterList.forEach(function (filter, index) {
        _this.props.onFilterUpdate(index, filter, _this.props.columns[index], 'custom');
      });
      _this.props.handleClose(); // close filter dialog popover

      if (_this.props.options.onFilterConfirm) {
        _this.props.options.onFilterConfirm(_this.state.filterList);
      }
      return _this.state.filterList;
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "resetFilters", function () {
      if (_this.props.options.confirmFilters === true) {
        _this.setState({
          filterList: _this.props.columns.map(function () {
            return [];
          })
        });
      } else {
        _this.props.onFilterReset();
      }
    });
    _this.state = {
      filterList: (0, _lodash.default)(props.filterList)
    };
    return _this;
  }
  _createClass(TableFilter, [{
    key: "renderCheckbox",
    value: function renderCheckbox(column, index) {
      var _this2 = this;
      var _this$props = this.props,
        classes = _this$props.classes,
        filterData = _this$props.filterData;
      var filterList = this.state.filterList;
      var renderItem = column.filterOptions && column.filterOptions.renderValue ? column.filterOptions.renderValue : function (v) {
        return v;
      };
      return /*#__PURE__*/_react.default.createElement(_core.GridListTile, {
        key: index,
        cols: 2
      }, /*#__PURE__*/_react.default.createElement(_FormGroup.default, null, /*#__PURE__*/_react.default.createElement(_core.Grid, {
        item: true,
        xs: 12
      }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
        variant: "body2",
        className: classes.checkboxListTitle
      }, column.label)), /*#__PURE__*/_react.default.createElement(_core.Grid, {
        container: true
      }, filterData[index].map(function (filterValue, filterIndex) {
        return /*#__PURE__*/_react.default.createElement(_core.Grid, {
          item: true,
          key: filterIndex
        }, /*#__PURE__*/_react.default.createElement(_FormControlLabel.default, {
          key: filterIndex,
          classes: {
            root: classes.checkboxFormControl,
            label: classes.checkboxFormControlLabel
          },
          control: /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
            className: classes.checkboxIcon,
            onChange: _this2.handleCheckboxChange.bind(null, index, filterValue, column.name),
            checked: filterList[index].indexOf(filterValue) >= 0,
            classes: {
              root: classes.checkbox,
              checked: classes.checked
            },
            value: filterValue != null ? filterValue.toString() : ''
          }),
          label: renderItem(filterValue)
        }));
      }))));
    }
  }, {
    key: "renderSelect",
    value: function renderSelect(column, index) {
      var _this3 = this;
      var _this$props2 = this.props,
        classes = _this$props2.classes,
        filterData = _this$props2.filterData,
        options = _this$props2.options;
      var filterList = this.state.filterList;
      var textLabels = options.textLabels.filter;
      var renderItem = column.filterOptions && column.filterOptions.renderValue ? column.filterOptions.renderValue : function (v) {
        return v != null ? v.toString() : '';
      };
      return /*#__PURE__*/_react.default.createElement(_core.GridListTile, {
        key: index,
        cols: 1,
        classes: {
          tile: classes.gridListTile
        }
      }, /*#__PURE__*/_react.default.createElement(_FormControl.default, {
        key: index,
        fullWidth: true
      }, /*#__PURE__*/_react.default.createElement(_InputLabel.default, {
        htmlFor: column.name
      }, column.label), /*#__PURE__*/_react.default.createElement(_Select.default, {
        fullWidth: true,
        value: filterList[index].length ? filterList[index].toString() : textLabels.all,
        name: column.name,
        onChange: function onChange(event) {
          return _this3.handleDropdownChange(event, index, column.name);
        },
        input: /*#__PURE__*/_react.default.createElement(_Input.default, {
          name: column.name,
          id: column.name
        })
      }, /*#__PURE__*/_react.default.createElement(_MenuItem.default, {
        value: textLabels.all,
        key: 0
      }, textLabels.all), filterData[index].map(function (filterValue, filterIndex) {
        return /*#__PURE__*/_react.default.createElement(_MenuItem.default, {
          value: filterValue,
          key: filterIndex + 1
        }, renderItem(filterValue));
      }))));
    }
  }, {
    key: "renderTextField",
    value: function renderTextField(column, index) {
      var _this4 = this;
      var classes = this.props.classes;
      var filterList = this.state.filterList;
      if (column.filterOptions && column.filterOptions.renderValue) {
        console.warn('Custom renderValue not supported for textField filters');
      }
      return /*#__PURE__*/_react.default.createElement(_core.GridListTile, {
        key: index,
        cols: 1,
        classes: {
          tile: classes.gridListTile
        }
      }, /*#__PURE__*/_react.default.createElement(_FormControl.default, {
        key: index,
        fullWidth: true
      }, /*#__PURE__*/_react.default.createElement(_core.TextField, {
        fullWidth: true,
        label: column.label,
        value: filterList[index].toString() || '',
        "data-testid": "filtertextfield-".concat(column.name),
        onChange: function onChange(event) {
          return _this4.handleTextFieldChange(event, index, column.name);
        }
      })));
    }
  }, {
    key: "renderMultiselect",
    value: function renderMultiselect(column, index) {
      var _this5 = this;
      var _this$props3 = this.props,
        classes = _this$props3.classes,
        filterData = _this$props3.filterData;
      var filterList = this.state.filterList;
      var renderItem = column.filterOptions && column.filterOptions.renderValue ? column.filterOptions.renderValue : function (v) {
        return v;
      };
      return /*#__PURE__*/_react.default.createElement(_core.GridListTile, {
        key: index,
        cols: 1,
        classes: {
          tile: classes.gridListTile
        }
      }, /*#__PURE__*/_react.default.createElement(_FormControl.default, {
        key: index,
        fullWidth: true
      }, /*#__PURE__*/_react.default.createElement(_InputLabel.default, {
        htmlFor: column.name
      }, column.label), /*#__PURE__*/_react.default.createElement(_Select.default, {
        multiple: true,
        fullWidth: true,
        value: filterList[index] || [],
        renderValue: function renderValue(selected) {
          return selected.map(renderItem).join(', ');
        },
        name: column.name,
        onChange: function onChange(event) {
          return _this5.handleMultiselectChange(index, event.target.value, column.name);
        },
        input: /*#__PURE__*/_react.default.createElement(_Input.default, {
          name: column.name,
          id: column.name
        })
      }, filterData[index].map(function (filterValue, filterIndex) {
        return /*#__PURE__*/_react.default.createElement(_MenuItem.default, {
          value: filterValue,
          key: filterIndex + 1
        }, /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
          checked: filterList[index].indexOf(filterValue) >= 0,
          value: filterValue != null ? filterValue.toString() : '',
          className: classes.checkboxIcon,
          classes: {
            root: classes.checkbox,
            checked: classes.checked
          }
        }), /*#__PURE__*/_react.default.createElement(_ListItemText.default, {
          primary: renderItem(filterValue)
        }));
      }))));
    }
  }, {
    key: "renderCustomField",
    value: function renderCustomField(column, index) {
      var _this$props4 = this.props,
        classes = _this$props4.classes,
        filterData = _this$props4.filterData,
        options = _this$props4.options;
      var filterList = this.state.filterList;
      var display = column.filterOptions && column.filterOptions.display || options.filterOptions && options.filterOptions.display;
      if (!display) {
        console.error('Property "display" is required when using custom filter type.');
        return;
      }
      if (column.filterListOptions && column.filterListOptions.renderValue) {
        console.warning('"renderValue" is ignored for custom filter fields');
      }
      return /*#__PURE__*/_react.default.createElement(_core.GridListTile, {
        key: index,
        cols: 1,
        classes: {
          tile: classes.gridListTile
        }
      }, /*#__PURE__*/_react.default.createElement(_FormControl.default, {
        key: index,
        fullWidth: true
      }, display(filterList, this.handleCustomChange, index, column, filterData)));
    }
  }, {
    key: "render",
    value: function render() {
      var _this6 = this;
      var _this$props5 = this.props,
        classes = _this$props5.classes,
        columns = _this$props5.columns,
        options = _this$props5.options,
        onFilterReset = _this$props5.onFilterReset,
        customFooter = _this$props5.customFooter,
        filterList = _this$props5.filterList;
      var textLabels = options.textLabels.filter;
      var filterGridColumns = columns.filter(function (col) {
        return col.filter;
      }).length === 1 ? 1 : 2;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: classes.root
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: classes.header
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: classes.reset
      }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
        variant: "body2",
        className: (0, _classnames.default)(_defineProperty2({}, classes.title, true))
      }, textLabels.title), /*#__PURE__*/_react.default.createElement(_Button.default, {
        color: "primary",
        className: classes.resetLink,
        tabIndex: 0,
        "aria-label": textLabels.reset,
        "data-testid": "filterReset-button",
        onClick: this.resetFilters
      }, textLabels.reset)), /*#__PURE__*/_react.default.createElement("div", {
        className: classes.filtersSelected
      })), /*#__PURE__*/_react.default.createElement(_core.GridList, {
        cellHeight: "auto",
        cols: filterGridColumns,
        spacing: 34
      }, columns.map(function (column, index) {
        if (column.filter) {
          var filterType = column.filterType || options.filterType;
          return filterType === 'checkbox' ? _this6.renderCheckbox(column, index) : filterType === 'multiselect' ? _this6.renderMultiselect(column, index) : filterType === 'textField' ? _this6.renderTextField(column, index) : filterType === 'custom' ? _this6.renderCustomField(column, index) : _this6.renderSelect(column, index);
        }
      })), customFooter ? customFooter(filterList, this.applyFilters) : '');
    }
  }]);
  return TableFilter;
}(_react.default.Component);
_defineProperty(TableFilter, "propTypes", {
  /** Data used to populate filter dropdown/checkbox */
  filterData: _propTypes.default.array.isRequired,
  /** Data selected to be filtered against dropdown/checkbox */
  filterList: _propTypes.default.array.isRequired,
  /** Options used to describe table */
  options: _propTypes.default.object.isRequired,
  /** Callback to trigger filter update */
  onFilterUpdate: _propTypes.default.func,
  /** Callback to trigger filter reset */
  onFilterReset: _propTypes.default.func,
  /** Extend the style applied to components */
  classes: _propTypes.default.object
});
var _default = (0, _styles.withStyles)(defaultFilterStyles, {
  name: 'MUIDataTableFilter'
})(TableFilter);
exports.default = _default;